<template>
  <div class="form-floating custom-tags-container" :class="{ 'focused': isFocused, 'has-value': modelValue.length > 0 || inputValue }" @click="focusInput">
    <div class="tags-content">
      <span class="badge d-flex align-items-center py-1 rounded-pill" v-for="(email, index) in modelValue" :key="index">
        {{ email }}
        <button type="button" class="btn-close btn-close-white ms-2" @click.stop="removeTag(index)"></button>
      </span>

      <input ref="emailInput"
             id="ccEmail"
             type="text"
             class="flex-grow-1 border-0 m-0 p-1"
             placeholder=" "
             v-model="inputValue"
             @keydown="handleKeyDown"
             @focus="isFocused = true"
             @blur="handleBlur">
    </div>

    <label for="ccEmail" class="custom-label">{{ $t('externalPatient.ccEmail') }}</label>
  </div>
</template>

<style scoped lang="scss">
.custom-tags-container {
  @include                      border_radius(5px);
  position:                     relative;
  display:                      flex;
  min-height:                   55px;
  height:                       auto !important;
  transition:                   all 0.2s;
  border:                       1px solid var(--Shades-60-Border);
  background:                   var(--Shades-W);
  cursor:                       text;

  &.focused {
    @include                    box_shadow(0 0 0 0.25rem rgba(13, 110, 253, 0.1));
    border-color:               var(--Brand-Primary);
  }

  .tags-content {
    display:                    flex;
    flex-wrap:                  wrap;
    align-items:                center;
    gap:                        4px;
    width:                      100%;
    padding:                    1.5rem 0.75rem 0.4rem 0.75rem;

    .badge {
      background:               var(--Brand-Secondary);
      z-index:                  3;

      button {
        font-size:              0.5rem;
      }
    }
  }

  .custom-label {
    @include                    transition(all 0.2s ease-in-out);
    color:                      var(--Shades-50);
    // font-size:                  12px;
    text-transform:             uppercase;
    letter-spacing:             1.65px;
    position:                   absolute;
    top:                        0;
    left:                       0;
    padding:                    1rem 0.75rem;
    // line-height:                1.6;
    pointer-events:             none;
    transform-origin:           0 0;
  }

  &.focused .custom-label,
  &.has-value .custom-label {
    @include                    transform(scale(0.85) translateY(-0.5rem) translateX(0.15rem));
    font-size:                  11px;
    font-weight:                400;
  }
}

input#ccEmail {
  @include                      box_shadow(none);
  color:                        var(--Brand-Primary);
  font-weight:                  500;
  flex:                         1;
  height:                       auto !important;
  min-height:                   24px;
  min-width:                    120px;
  padding:                      0 !important;
  margin:                       0 !important;
  border:                       none !important;
  background:                   transparent;
  outline:                      none;

  &::placeholder,
  &:-ms-input-placeholder {
    color:                      transparent !important;
    opacity:                    0 !important;
  }
}
</style>

<script>
export default {
  name: 'BaseEmailTagInput',
  props: {
    modelValue: { type: Array, default: () => [] },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      inputValue: '',
      isFocused: false,
      error: ''
    };
  },
  methods: {
    addTag() {
      const email = this.inputValue.trim().replace(/,/g, '');
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const currentTags = this.modelValue || [];

      if (!email) return;

      if (emailRegex.test(email)) {
        if (!currentTags.includes(email)) {
          this.$emit('update:modelValue', [...currentTags, email]);
          this.error = '';
        } else {
          this.error = this.$i18n.t('externalPatient.emailAlreadyAdded');
        }
        this.inputValue = '';
      } else {
        this.error = this.$i18n.t('externalPatient.invalidEmail');
      }
    },
    removeTag(index) {
      const currentTags = this.modelValue || [];
      const newTags = [...currentTags];
      newTags.splice(index, 1);
      this.$emit('update:modelValue', newTags);
    },
    handleKeyDown(e) {
      if (e.key === ',' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.addTag();
      }
      if (e.key === 'Backspace' && !this.inputValue && this.modelValue?.length > 0) {
        this.removeTag(this.modelValue.length - 1);
      }
    },
    handleBlur() {
      this.isFocused = false;
      if (this.inputValue) this.addTag();
    }
  }
};
</script>
